module.exports = __webpack_public_path__ + "img/6.50d73832.png";